"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');



var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);
var _useBus = require('shared/hooks/useBus'); var _useBus2 = _interopRequireDefault(_useBus);
var _typed = require('shared/hooks/typed');
var _feature = require('shared/selectors/user/feature');
var _types = require('../useInbox/types');
var _utils = require('../useInbox/utils');

// The pills that carry a count. Unread's number is All's UnreadChats, so it
// needs no query of its own.
const COUNTED_TABS = [_types.InboxTab.ALL, _types.InboxTab.PATIENTS, _types.InboxTab.TEAM, _types.InboxTab.SCHEDULED] 



// Anything that can change a count: a chat update from the socket, losing
// access to a chat, opening a chat, archiving or unarchiving, a scheduled
// message changing, and a reconnect.
const REFRESH_ACTIONS = [
  _actionCreators2.default.updateNotificationAction.type,
  _actionCreators2.default.purgeNotificationAction.type,
  _actionCreators2.default.markBlobjectSeenActions.SUCCESS.type,
  _actionCreators2.default.completeBlobjectActions.SUCCESS.type,
  _actionCreators2.default.uncompleteBlobjectActions.SUCCESS.type,
  _actionCreators2.default.setBlobjectCompletedForTeamsActions.SUCCESS.type,
  _actionCreators2.default.createConversationActions.SUCCESS.type,
  _actionCreators2.default.createSmsConversationActions.SUCCESS.type,
  _actionCreators2.default.scheduledMessageUpdateNotificationAction.type,
  _actionCreators2.default.scheduleMessageActions.SUCCESS.type,
  _actionCreators2.default.cancelScheduledMessageActions.SUCCESS.type,
  _actionCreators2.default.sendScheduledMessageNowActions.SUCCESS.type,
  'SOCKET_CONNECTED',
  'SERVER_ACK_SOCKET_CONNECTED',
]

// A burst of events (a busy inbox, a bulk archive) asks once, this long after
// its first event.
 const COUNTS_REFRESH_MS = 1500; exports.COUNTS_REFRESH_MS = COUNTS_REFRESH_MS











const listKey = (teamKey, isArchived) => `${_nullishCoalesce(teamKey, () => ( 'mine'))}/${isArchived}`

/* The pills' counts for the inbox and archive state on screen, from one
 * GetInboxCounts request (#1152). The server counts each list on its own: a
 * list it couldn't count is missing from the answer, and its pill shows
 * without a number. Null while they load for this list, or when the request
 * fails, so the pills show without numbers. A refresh asked for while one is
 * running waits for it, then runs once. Without the INBOX_COUNTS feature it
 * never asks, and is always null. */
 const useInboxCounts = ({
  teamKey,
  isArchived,
  canSeePatients,
  tabs: onlyTabs = COUNTED_TABS,
}) => {
  const isEnabled = _typed.useAppSelector.call(void 0, _feature.selectCurrentUserHasInboxCountsFeature)
  const [state, setState] = _react.useState(null)
  const generationRef = _react.useRef.call(void 0, 0)
  const timerRef = _react.useRef(null)
  // The load running now, and whether a refresh was asked for meanwhile.
  const inFlightRef = _react.useRef(null)
  const isRefreshWaitingRef = _react.useRef.call(void 0, false)
  const scheduleLoadRef = _react.useRef(() => undefined)

  const load = _react.useCallback.call(void 0, async () => {
    const generation = ++generationRef.current
    inFlightRef.current = generation
    isRefreshWaitingRef.current = false
    const key = listKey(teamKey, isArchived)
    const tabs = onlyTabs.filter(t => t !== _types.InboxTab.PATIENTS || canSeePatients)
    const queries = tabs.map(tab => ({
      Id: tab,
      TeamKey: teamKey,
      Completed: isArchived,
      ..._utils.tabRequestFields.call(void 0, tab),
    }))
    const response = await _actions2.default.getInboxCounts(queries).catch(() => null)
    if (inFlightRef.current === generation) inFlightRef.current = null
    if (generation !== generationRef.current) return
    const counts = response
      ? Object.fromEntries(response.Counts.map(c => [c.Id, c])) 
      : null
    setState({ key, counts })
    if (isRefreshWaitingRef.current) {
      isRefreshWaitingRef.current = false
      scheduleLoadRef.current()
    }
  }, [teamKey, isArchived, canSeePatients, onlyTabs])

  const scheduleLoad = _react.useCallback.call(void 0, () => {
    if (!isEnabled) return
    if (inFlightRef.current !== null) {
      isRefreshWaitingRef.current = true
      return
    }
    if (timerRef.current) return
    timerRef.current = setTimeout(() => {
      timerRef.current = null
      if (inFlightRef.current !== null) {
        isRefreshWaitingRef.current = true
        return
      }
      load()
    }, exports.COUNTS_REFRESH_MS)
  }, [load, isEnabled])
  scheduleLoadRef.current = scheduleLoad

  _react.useEffect.call(void 0, () => {
    if (!isEnabled) return undefined
    load()
    return () => {
      generationRef.current += 1
      if (timerRef.current) clearTimeout(timerRef.current)
      timerRef.current = null
    }
  }, [load, isEnabled])

  _useBus2.default.call(void 0, REFRESH_ACTIONS, scheduleLoad)

  if (!isEnabled) return null
  return _optionalChain([state, 'optionalAccess', _ => _.key]) === listKey(teamKey, isArchived) ? state.counts : null
}; exports.useInboxCounts = useInboxCounts
